export const isFlutterInAppWebView = () => Boolean(typeof window !== "undefined" && window.flutter_inappwebview?.callHandler);

export const shouldUseCustomDatePicker = () => {
  if (isFlutterInAppWebView()) {
    return true;
  }

  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  return /; wv\)/i.test(userAgent) || /WebView/i.test(userAgent);
};

const NATIVE_CLOSE_HANDLERS = ["close", "closeWebView", "dismiss"];

const notifyNativeWebViewClose = async () => {
  if (!isFlutterInAppWebView()) {
    return false;
  }

  for (const handlerName of NATIVE_CLOSE_HANDLERS) {
    try {
      await window.flutter_inappwebview.callHandler(handlerName);
      return true;
    } catch {
      // Try the next handler name supported by the host app.
    }
  }

  return false;
};

const waitMs = (ms) =>
  new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });

/**
 * Attempts to close an in-app WebView or browser tab opened from email/deep links.
 * iOS Safari blocks window.close() unless the tab was opened via script.
 */
export const closeBrowserOrWebView = async ({ fallbackPath = "/login", allowHistoryBackWhenSingleEntry = false } = {}) => {
  if (await notifyNativeWebViewClose()) {
    return;
  }

  const canTryHistoryBack = window.history.length > 1 || allowHistoryBackWhenSingleEntry;
  if (canTryHistoryBack) {
    window.history.back();
    await waitMs(400);

    if (document.hidden) {
      return;
    }
  }

  window.close();
  await waitMs(250);

  if (window.closed) {
    return;
  }

  if (fallbackPath) {
    window.location.replace(fallbackPath);
  }
};
